import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { api, setAdminToken } from "../../lib/api";

export default function AdminLogin() {
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const submit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const { data } = await api.post("/admin/login", { password });
            setAdminToken(data.token);
            toast.success("Welcome, Admin.");
            navigate("/admin/dashboard");
        } catch (err) {
            toast.error(
                err?.response?.data?.detail || "Invalid password.",
            );
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen bg-[#F3EFE9] flex items-center justify-center px-6">
            <div className="w-full max-w-md bg-white border border-[#E6DFD3] rounded-2xl p-10 shadow-[0_8px_40px_rgba(13,27,26,0.06)]">
                <div className="flex items-center gap-3 mb-6">
                    <div className="w-10 h-10 rounded-full bg-[#1A5C53]/10 text-[#1A5C53] flex items-center justify-center">
                        <Lock size={18} />
                    </div>
                    <div>
                        <div className="font-serif text-2xl text-[#0D1B1A]">
                            DhanNniti · Admin
                        </div>
                        <div className="text-xs text-[#758684]">
                            Restricted area
                        </div>
                    </div>
                </div>

                <form onSubmit={submit} className="space-y-5">
                    <div>
                        <Label htmlFor="pwd">Admin Password</Label>
                        <Input
                            id="pwd"
                            type="password"
                            data-testid="admin-password-input"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            placeholder="••••••••"
                            className="mt-2 bg-[#FDFAF5] border-[#E6DFD3]"
                        />
                    </div>

                    <button
                        type="submit"
                        disabled={loading}
                        data-testid="admin-login-btn"
                        className="w-full bg-[#1A5C53] text-white hover:bg-[#13423B] disabled:opacity-60 rounded-md px-6 py-3 font-medium flex items-center justify-center gap-2"
                    >
                        {loading && (
                            <Loader2 size={16} className="animate-spin" />
                        )}
                        Sign In
                    </button>
                </form>
            </div>
        </div>
    );
}
